import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { I18nModule, provideConfig } from '@spartacus/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { AtgContactUsDialogComponent } from './atg-contact-us-dialog.component';
import { atgOccEndpointsConfig } from '../core/occ/atg-occ-endpoints.config';

@NgModule({
  declarations: [AtgContactUsDialogComponent],
  imports: [CommonModule, ReactiveFormsModule, I18nModule, NgSelectModule],
  exports: [AtgContactUsDialogComponent],
  providers: [
    provideConfig(atgOccEndpointsConfig),
  ],
})
export class AtgContactUsDialogModule {}
